import React, { useCallback, useEffect, useRef, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import LogoutConfimation from "./LogoutConfimation";
import { getSingleStudent, logOut, useUser } from "../../redux/services/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import logo from "../../assests/BEFLogo.png";
import { FaBars } from "react-icons/fa";
import { IoIosArrowDown } from "react-icons/io";

const Navbar = ({ toggleSidebar }) => {
  const location = useLocation();
  const { pathname } = location;
  const { user } = useUser();
  const dispatch = useDispatch();
  const singleUserData = useSelector((state) => state.auth?.singleUser);
  const userId = localStorage.getItem("userId");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const navigate = useNavigate();
  const toggleDropdown = () => setDropdownOpen((prevState) => !prevState);
  const handleToggle = () => setConfirm((prevState) => !prevState);
  const menuRef = useRef();
  const handleLogout = () => {
    setTimeout(() => {
      navigate("/");
      setConfirm(!confirm);
      dispatch(logOut());
    }, 1000);
  };
  const getSingleRecord = useCallback(async () => {
    try {
      await dispatch(getSingleStudent(userId  ));
    } catch (error) {}
  }, [dispatch, userId]);

  useEffect(() => {
    if (userId) {
      getSingleRecord();
    }
  }, [userId, getSingleRecord]);
  const confirmLogout = () => {
    handleLogout();
    toast.success("Logout successfully", {
      autoClose: 2000,
      pauseOnHover: false,
    });
  };
  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (
        dropdownOpen &&
        menuRef.current &&
        !menuRef.current.contains(e.target)
      ) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("click", checkIfClickedOutside);
    return () => {
      document.removeEventListener("click", checkIfClickedOutside);
    };
  }, [dropdownOpen]);
  return (
    <>
      <header className="sticky top-0 z-50 h-[80px] flex items-center justify-between bg-white shadow-md px-4">
        <div className="flex gap-3">
          <button
            className="lg:hidden text-gray-600 text-2xl"
            onClick={toggleSidebar}
          >
            <FaBars />
          </button>
          <div className="flex flex-col items-start justify-center cursor-pointer py-1" onClick={()=>navigate("/")}>
            <img src={logo} alt="Achiwon" className="h-8 w-auto object-contain" />
            <span className="text-[10px] text-[#F48224] font-semibold tracking-wider leading-none mt-1">
              UPSC & GPSC CSE
            </span>
          </div>
        </div>
        <div className="flex justify-end">
          <div className="items-center gap-x-3 flex px-4">
            <div className="relative">
              <div
                onClick={(e) => { 
                  e.stopPropagation();
                  setDropdownOpen((prevState) => !prevState);
                }}
                className="flex items-center gap-2 cursor-pointer"
              >
                <span className="h-12 w-12 rounded-full flex justify-center items-center">
                  <img
                    src={logo}
                    alt={user.name}
                    className="w-full h-full rounded-full object-cover"
                  />
                </span>
                <div className="hidden sm:block text-left cursor-pointer ">
                  <span className="block text-sm font-medium text-black">
                    {(singleUserData?.firstName ||user?.firstName) + " " + (singleUserData?.lastName || user?.lastName) || "Welcome user"}
                  </span>
                  <span className="block text-xs">{singleUserData?.name ||user.name}</span>
                </div>
               <IoIosArrowDown />
              </div>
              {dropdownOpen && (
                <div
                  ref={menuRef}
                  className="absolute right-0 sm:right-0 top-14 w-56 rounded-md bg-white p-2 shadow-lg"
                >
                  <ul className="font-semibold space-y-2 mb-0">
                    <li onClick={toggleDropdown}>
                      <NavLink to="/change-password">
                        <button
                          type="button"
                          className={`${
                            pathname === "/change-password"
                              ? "text-white bg-[#124699]"
                              : "text-black"
                          } py-2 px-4 w-full hover:text-black hover:bg-[#e8effa] rounded-md`}
                        >
                          Change Password
                        </button>
                      </NavLink>
                    </li>
                    <li onClick={handleToggle}>
                      <button
                        type="button"
                        className="py-2 px-4 w-full hover:bg-[#e8effa] rounded-md"
                      >
                        Log Out
                      </button>
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>
      </header>
      {confirm && (
        <LogoutConfimation
          confirm={confirm}
          onLogout={confirmLogout}
          onCancel={() => setConfirm(!confirm)}
        />
      )}
    </>
  );
};

export default Navbar;
